import React, { useState } from 'react'
import { imagesData } from "@atoms";
import { useRecoilState } from 'recoil';
import './style.css'

const DeleteConfirm = ({
  handleCloseModal,
  modalData,
}) => {
  const [images, setImages] = useRecoilState(imagesData);
  const [imageLoaded, setImageLoaded] = useState(false);

  const imageUrl = `${modalData?.data?.image}`;

  const handleDeleteImage = () => {
    modalData.onDelete();
    handleCloseModal('deleteConfirm');
  }

  const handleCancelDelete = () => {
    const imageId = modalData.data._id;
    const updateImages = images.map(item => item._id === imageId ? ({ ...item, keepImage: true }) : item);
    setImages(updateImages);
    modalData.onKeepImage(imageId);
    handleCloseModal('deleteConfirm');
  }

  return (
    <div className="dc-modal" dir="rtl">
      {/* Top visual band with blurred background image */}
      <div className="dc-modal__visual">
        <div
          className="dc-modal__visual-bg"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="dc-modal__visual-overlay" />

        {/* Warning badge */}
        <div className="dc-modal__badge">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>איכות נמוכה</span>
        </div>

        {/* Image container with skeleton */}
        <div className="dc-modal__image-frame">
          {!imageLoaded && (
            <div className="dc-modal__skeleton">
              <div className="dc-modal__skeleton-shimmer" />
            </div>
          )}
          <img
            src={imageUrl}
            alt="preview"
            className={`dc-modal__image ${imageLoaded ? 'dc-modal__image--loaded' : ''}`}
            onLoad={() => setImageLoaded(true)}
          />
        </div>
      </div>

      {/* Content area */}
      <div className="dc-modal__content">
        <h2 className="dc-modal__title">תמונה באיכות נמוכה</h2>
        <p className="dc-modal__desc">
          התמונה הזו כנראה תצא מטושטשת בהדפסה, אתם בטוחים שתרצו להשאיר אותה?
        </p>
      </div>

      {/* Actions */}
      <div className="dc-modal__actions">
        <button onClick={handleCancelDelete} className="dc-modal__btn dc-modal__btn--keep">
          השאר את התמונה בכל זאת
        </button>
        <button onClick={handleDeleteImage} className="dc-modal__btn dc-modal__btn--delete">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          </svg>
          מחיקה
        </button>
      </div>
    </div>
  )
}

export default DeleteConfirm;
